import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from "react";
import Icon from "../../../../base/icons/icon/index.js";
import calculateStars from "../../../../../helpers/calculate-stars.js";
import { Stars } from "../../../../../styles/common/mixins/stars.styled.js";
import { ICONS } from "./constants.js";
export const getIcon = (name)=>{
    const key = name.toUpperCase();
    const icon = {
        TTOO: ICONS.ICO_TTOO,
        FLIGHTHOTEL: ICONS.ICO_FLIGHT_HOTEL,
        FERRYHOTEL: ICONS.ICO_FERRY_HOTEL,
        TRAINHOTEL: ICONS.ICO_TRAIN_HOTEL,
        BUSHOTEL: ICONS.ICO_BUS_HOTEL,
        LEI: ICONS.ICO_LEI,
        SKI: ICONS.ICO_SKI,
        DISNEY: ICONS.ICO_DIS,
        GVCOMB: ICONS.ICO_GV_COMB,
        GVCIR: ICONS.ICO_GV_CIR,
        GVRUT: ICONS.ICO_GV_RUT,
        FLIGHT: ICONS.ICO_FLIGHT,
        TRAIN: ICONS.ICO_TRAIN,
        FERRY: ICONS.ICO_FERRY,
        BUS: ICONS.ICO_BUS,
        HOTEL: ICONS.ICO_HOTEL,
        STAR: ICONS.ICO_STAR,
        KEY: ICONS.ICO_KEY,
        SAFE: ICONS.ICO_SAFE,
        REVIEW: ICONS.ICO_REVIEW,
        MAGNIFIER: ICONS.ICO_MAGNIFIER
    }[key];
    return icon ?? ICONS.ICO_STAR;
};
export const getIconTransport = (product)=>{
    const key = product.toUpperCase();
    const icon = {
        FLIGHTHOTEL: ICONS.ICO_PLANE,
        FERRYHOTEL: ICONS.ICO_FERRY,
        TRAINHOTEL: ICONS.ICO_TRAIN,
        BUSHOTEL: ICONS.ICO_BUS
    }[key];
    return icon ?? ICONS.ICO_PLANE;
};
export const ratingTemplate = (show, icon, value)=>{
    if (!show || !value || isNaN(value)) return;
    const stars = calculateStars({
        star: `nico-${getIcon(icon)}`,
        halfStar: 'nico-star-half-filled',
        value
    });
    return /*#__PURE__*/ _jsx(Stars, {
        children: Children.toArray(stars.map((icon)=>/*#__PURE__*/ _jsx(Icon, {
                "data-testid": "StarsIcon",
                className: icon
            })))
    });
};
export const getReviewContent = (value)=>{
    if (value <= 6) return 'good';
    if (value <= 8) return 'veryGood';
    return 'excelent';
};
const positiveNumberOrUndefined = (num)=>{
    if (num && num > 0) return num;
    return undefined;
};
export const normalizePrice = (price)=>({
        ...price,
        discount: positiveNumberOrUndefined(price?.discount),
        market_value: positiveNumberOrUndefined(price?.market_value),
        paxValue: positiveNumberOrUndefined(price?.paxValue),
        value: positiveNumberOrUndefined(price?.value)
    });

//# sourceMappingURL=index.js.map